import Layout from '../../components/controls/Layout'
import styles from './styles.module.css'

export default function TextArea({ props }) {
    const { register, name, label, description, ...input } = props

    return (
        <Layout name={name} label={label} description={description}>
            <div className={styles.Wrapper}>
                <textarea {...input} name={name} ref={register} id={name} onInput={handleInput} />
            </div>
        </Layout>
    )
}

// https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/
function handleInput({ target }) {
    target.parentNode.dataset.replicatedValue = target.value
}
